import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

const MentorProfilePicture = ({
  auth: { user },
  setprofilePicOpen,
  profile,
}) => {
  return (
    <Fragment>
      <div className="profile-picture-overlay">
        <div className="profile-avi-container">
          <i
            className="fas fa-times fa-3x profile-x"
            onClick={(e) => setprofilePicOpen(false)}
          ></i>
          <div className="profile-picture-circle red">
            <img
              className="profile-picture"
              src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${
                profile && profile.avatar
              }`}
              alt="avatar"
            />
          </div>
        </div>
      </div>
    </Fragment>
  );
};

MentorProfilePicture.propTypes = {
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps)(MentorProfilePicture);
